import React, {SetStateAction} from "react";
import {ErrorToast, SuccessToast} from "../toasters/toasters";
import {AdminBrandService} from "../../app/brand/service";

export const handleBrandIsActive  = async (id: number, setList: React.Dispatch<SetStateAction<any>>, t: any) => {
    id &&
   await AdminBrandService.updateIsActive(id)
        .then((response) => {
            if (response?.status === "success") {
                SuccessToast(t(`brand.successfully_updated`));
                setList((prevState: any) => prevState.map((listItem: any) => {
                    if (listItem?.id === id) {
                        return {
                            ...listItem,
                            active: !listItem.active
                        }
                    }
                    return listItem;
                }) as [])
            }
        })
        .catch((error) => ErrorToast(error));
}